import { Box, Stack } from '@mantine/core';
import type { EmbeddedPromptOut } from '@repo/api-codegen';
import { memo, useMemo } from 'react';
import {
	getAttachmentUrlsInPromptMessage,
	getFileNameFromUrl,
} from '../../../components/AIAssistant/utils';
import { Attachment } from './Attachment';

export const PromptAttachments = memo(
	({ message }: { message: EmbeddedPromptOut }) => {
		const attachments = useMemo(
			() => getAttachmentUrlsInPromptMessage(message.prompt),
			[message.prompt]
		);

		if (!attachments?.length) {
			return null;
		}

		return (
			<Stack spacing="xs" pb="xs">
				{attachments.map((url) => (
					<Box key={url}>
						<Attachment title={getFileNameFromUrl(url)} href={url} />
					</Box>
				))}
			</Stack>
		);
	}
);
